import request from '@/util/request';
import qs from 'qs';

//分页数据
export const getPage = (params, options) =>
request.get('/api/v4ward/feeInvoiceInfo/page', Object.assign({}, options, { params }));

//详情数据
export const getDetail = (params, options) =>
  request.get('/api/v4ward/feeInvoiceInfo/detail', Object.assign({}, options, { params }));

//发票红冲
export const invoiceRed = (params, options) =>
  request.post('/api/v4ward/invoice/sdpIssue-red', params,options);

//获取操作日志
export const invoiceOperateLogPage = (params, options) =>
  request.get('/api/v4ward/fee-invoice/operate-log/page', Object.assign({}, options, { params }));

// 发送发票到邮箱
export const sendEmail = (params, options) =>
    request.post('/api/v4ward/invoice/send-email', params, options);

// 重新开票
export const issueAgain = (params, options) =>
  request.post('/api/v4ward/invoice/issue-again', params, options);

//删除已开票的失败记录
export const delHasInvoiceFail = (params, options) =>
  request.post('/api/v4ward/invoice/del-fail-invoice', qs.stringify(params),options);
